module.exports = __webpack_public_path__ + "static/media/SVG_add_favorite_off.cd3e4708.svg";